<!-- Add this line on index.html -->
<!-- <script
    type="module"
    crossorigin
    src="https://assets.conekta.com/component/2.0.2/assets/component.min.js"
></script> -->
<app-breadcrumb [title]="'Agregar Método de Pago'" [breadcrumb]="'Métodos de Pago'"></app-breadcrumb>
<!-- personal deatail section start -->
<section class="contact-page register-page">
    <div class="container">
        <br>
        <br>
        <div class="row">
            <div class="col-lg-4 col-md-4">
                <p>Aceptamos la mayoría de las tarjetas de crédito y débito.</p>
                <div>
                    <img
                        src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRRpnNjfuJEGsuot0fXcQ-7_AXp-OWKzkgPac7fo8ETEEXxDpry9_51arMbfkhPHv6zfn4&usqp=CAU">
                </div>
            </div>
            <div class="col-lg-8 col-md-4">
                <div class="pull-left" id="conektaComponent" style="width: 500px; margin: 0 auto"></div>
            </div>
            <br>
        </div>
    </div>
</section>